import { render } from "./ManagerPlaceHolder.vue?vue&type=template&id=6641aa54"
import script from "./ManagerPlaceHolder.vue?vue&type=script&lang=js"
export * from "./ManagerPlaceHolder.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ManagerPlaceHolder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6641aa54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6641aa54', __exports__)) {
    api.reload('6641aa54', __exports__)
  }
  
  module.hot.accept("./ManagerPlaceHolder.vue?vue&type=template&id=6641aa54", () => {
    api.rerender('6641aa54', render)
  })

}


export default __exports__